import { PartnerApi } from '@calm/evexia-web-sdk/generated/lib/api/partner-api';
import { createApi } from './create-api';

/**
 * Helper function to configure and create a new instance of an `PartnerApi`
 * @param accessToken
 * @returns
 */
export default function createPartnerApi(
    accessToken: () => Promise<string>,
    // We can change this if we want to instead create an API for the server using a server client
    client = undefined
) {
    return createApi(PartnerApi, accessToken, client);
}
